module.exports = __webpack_public_path__ + "static/05-rowan-cake-8c3d47e081841eaaac1d2f2a3feced67.jpg";